import { render, staticRenderFns } from "./ProjectTaskTemplateDetailEditForm.vue?vue&type=template&id=15e898aa&"
import script from "./ProjectTaskTemplateDetailEditForm.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskTemplateDetailEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports